import { useEffect, useState } from "react";
import { api } from "../lib/config";
import EstimateCalculator from "../components/EstimateCalculator";
import TrustSignalsBar from "../components/TrustSignalsBar";
import { Sparkles, ShieldCheck, Clock } from "lucide-react";

export default function Estimate() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then(({ data }) => setServices(data.services || [])).catch(() => setServices([]));
  }, []);

  return (
    <div data-testid="estimate-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-50 border border-emerald-200 text-[10px] uppercase tracking-[0.22em] text-[#047857] font-extrabold">
          <Sparkles className="w-3 h-3" /> Instant Quote
        </div>
        <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tighter text-gray-900 font-[Outfit]">
          See your price in seconds.
        </h1>
        <p className="mt-2 text-gray-600 text-sm sm:text-base max-w-xl">
          Pick your service, set your yard size and frequency — your custom price updates live.
          No email, no phone number, no waiting. Ready to book? Tap <span className="font-bold text-[#047857]">Book this service</span> below.
        </p>

        <div className="mt-6">
          <EstimateCalculator services={services} />
        </div>

        {/* Trust strip — soft reassurance instead of a lead-capture form */}
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3">
          <TrustChip Icon={Clock} title="Instant quote" body="Real-time pricing, no callbacks." />
          <TrustChip Icon={ShieldCheck} title="No commitment" body="See your price before you share any details." />
          <TrustChip Icon={Sparkles} title="Premium service" body="Jacksonville's top-rated lawn care crew." />
        </div>
      </div>
      {/* iter103 — global trust signals row at bottom of estimate page */}
      <TrustSignalsBar />
    </div>
  );
}

function TrustChip({ Icon, title, body }) {
  return (
    <div className="rounded-2xl bg-white border border-gray-200 p-4 flex items-start gap-3">
      <div className="w-9 h-9 rounded-lg bg-emerald-50 text-[#047857] flex items-center justify-center flex-shrink-0">
        <Icon className="w-4 h-4" />
      </div>
      <div className="min-w-0">
        <div className="text-sm font-extrabold text-gray-900 tracking-tight">{title}</div>
        <div className="text-xs text-gray-600 mt-0.5">{body}</div>
      </div>
    </div>
  );
}
